import * as React from "react";
import Flexbox from "flexbox-react";
import { observer, Provider } from "mobx-react";
import ThemeWrapper from "../components/styles/ThemeWrapper/index.js";
import ToastStore from "../stores/ToastStore";
import Cookies from "js-cookie";
import ErrorBoundary from "../components/errors/ErrorBoundary";
import axios from "axios";
import CurrentUserStore from "../stores/CurrentUserStore.js";
import PageHeading from "../components/goals/PageHeading.js";
import "../components/goal_performance/MyAssessmentView.css";
import PerformanceTabSelector from "../components/goal_performance/PerformanceTabSelector.jsx";
import ScrollableDropdown from "../components/shared/ScrollableDropdown.jsx";
import PublishConfirmDialog from "../components/goal_performance/PublishConfirmDiaglog.js";
import { allowedExtensions } from "../static/Constant.js";
import { Card } from "@blueprintjs/core";
import EmptyStateNotice from "../components/goal_performance/EmptyStateNotice.js";
import SelfTabContent from "../components/goal_performance/SelfTabContent.jsx";
import ReviewTabContent from "../components/goal_performance/ReviewTabContent.jsx";
import ContainerIntroBox from "../components/goal_performance/ContainerIntroBox.js";
import AssessmentReadOnlyList from "../components/goal_performance/AssessmentReadOnlyList.js";
import ReadOnlyNotice from "../components/goal_performance/ReadOnlyNotice.js";
import AcknowledgementTabContent from "../components/goal_performance/AcknowledgementTabContent.js";

const SELF_ASSESSMENT_STATUS = {
  NOT_SUBMITTED: 0,
  DRAFT: 1,
  SUBMITTED: 2
};

const STEP_TYPES = [
  { label: "Self", value: 0 },
  { label: "Review", value: 1 },
  { label: "Other", value: 2 }
];

@observer
export default class MyAssessmentView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: "assessment",
      selectedTimeframe: {},
      selfAssessmentStatus: 0,

      goalCycleList: [],
      goalList: [],
      goalSubmittedList: [],
      assessmentQuestionList: [],
      assessmentSubmittedList: [],
      reviewSubmittedListByManager: [],
      reviewSubmittedCatGroupListByManager: [],
      reviewRatingByManager: "",
      reviewRatingLabelByManager: "",
      goalSubmittedListByManager: [],
      goalRatingByManager: "",
      goalRatingLabelByManager: "",
      currentReviewStepStatus: null,
      acknowledgementMode: false,
      acknowledgementData: null,
      answers: [],
      assessmentRatings: {},
      assessmentRatingsCalculation: [],
      assessmentRatingSubmit: [],
      finalAssessmentRating: "",
      finalAssesCalcRatingLabel: "",
      finalSubmittedAssessmentRating: "",
      finalSubmittedAssessmentRatingLabel: "",
      goalRatings: {},
      goalRatingsSubmit: [],
      goalRatingsCalculation: [],
      finalRating: "",
      goalSubmittedRatingLabel: "",
      finalGoalCalcRatingLabel: "",
      responseFinalRating: "",
      responseFinalRatingLabel: "",
      assessmentQuestionGroups: [],
      check_in: [],
      selectedCheckIn: null,
      isLoadingCheckIn: false,
      showCheckInDropdown: false,

      // multi-level review (manager tab)
      multiLevelReview: false,
      reviewSteps: [],
      selectedStep: null,

      isLoading: false,
      showPublishConfirm: false,

      resultData: {
        assessmentRatingMethodResult: "",
        goalRatingMethodResult: "",
        finalAssessmentRatingLabel: "",
        finalGoalRatingLabel: "",
      },
      subGoalsByGoalId: {},
      openSubGoals: {},
      assessmentSubmittedGroups: [],
      categoryWiseRatings: {},
      categoryFinalRating: "",
      SPECIAL_ACCOUNT_ID: "43ee1008-2c55-4cb5-b3f9-872d714618db",
      ALLOWED_QUESTION_ID: ["1c5c5739-4d7a-4929-bd02-9b13fab79913", "847ea7b2-bcd1-4b32-b614-af73e8a8804a"],
      managerGlobalRating: "",
      managerGlobalRatingLabel: "",
      remarkAnswers: {},
    };
  }

  isStepContentUnlocked = (step) => {
    const { reviewSteps } = this.state;
    if (!step) return false;
    if (step.step_type === 0) return true;

    const stepIndex = reviewSteps.findIndex(s => s.id === step.id);
    if (stepIndex < 0) return true;

    const previousSteps = reviewSteps.slice(0, stepIndex);
    return previousSteps.every(prevStep => prevStep.is_submitted);
  };

  getTabs = () => {
    const { reviewSteps } = this.state;

    let tabs = [];

    reviewSteps.forEach(step => {
      const stepType = STEP_TYPES.find(type => type.value === step.step_type);
      const label =
        step.step_type === 0
          ? "Assessment"
          : stepType?.label === "Review"
            ? step.step_name || "Review"
            : step.step_name || "Other";

      const type =
        step.step_type === 1 ? "review" : "assessment";

      tabs.push({
        key: step.id,
        label,
        type,
        step_type: step.step_type
      });
    });

    return tabs;
  };

  getNumericRating = (value) => {
    if (value === null || value === "" || Number.isNaN(Number(value))) return null;
    return Number(value);
  };

  getCurrentReviewStep = () => {
    const { activeTab, selectedStep, reviewSteps } = this.state;
    if (!activeTab || activeTab === "assessment" || activeTab === "acknowledgement") {
      return null;
    }
    if (selectedStep?.id === activeTab) return selectedStep;
    return reviewSteps.find(step => step.id === activeTab) || null;
  };

  getCurrentReviewProcessStepId = () => {
    const currentStep = this.getCurrentReviewStep();
    if (currentStep?.id) return currentStep.id;
    return this.state.selectedTimeframe?.review_process_step_id || null;
  };

  getCurrentReviewUserId = () => {
    const currentStep = this.getCurrentReviewStep();
    if (!currentStep) return CurrentUserStore.currentUser.id;

    if (Array.isArray(currentStep.assignee_list) && currentStep.assignee_list.length > 0) {
      return currentStep.assignee_list[0];
    }

    if (currentStep.assigned_user_id) {
      return currentStep.assigned_user_id;
    }

    return CurrentUserStore.currentUser.id;
  };

  getSubmittedByUserId = () => CurrentUserStore.currentUser.id;

  isCurrentUserAuthorizedToSubmitCurrentStep = () => {
    const { selectedStep } = this.state;
    if (!selectedStep || selectedStep.step_type === 0 || (selectedStep.step_type === 2 && selectedStep.assign_type === 0)) return true;

    const currentUserId = CurrentUserStore.currentUser.id;
    const currentJobProfileId = CurrentUserStore.currentUser.job_profile_id;

    // If a review step has no explicit assignment, allow the current user to submit.
    if (
      selectedStep.assign_type == null &&
      (!Array.isArray(selectedStep.assignee_list) || selectedStep.assignee_list.length === 0) &&
      !selectedStep.assigned_user_id
    ) {
      return true;
    }

    if (selectedStep.assign_type === 2) {
      return Array.isArray(selectedStep.assignee_list) &&
        selectedStep.assignee_list.map(String).includes(String(currentUserId));
    }

    if (selectedStep.assign_type === 1) {
      return Array.isArray(selectedStep.assignee_list) &&
        selectedStep.assignee_list.map(String).includes(String(currentJobProfileId));
    }

    return selectedStep.assigned_user_id === currentUserId;
  };

  formatReviewAnswerValue = (answerValue, answerType) => {
    if (answerValue === null || answerValue === undefined) return "";

    if (answerType === "Checkbox" || answerType === "Files") {
      if (typeof answerValue === "object") {
        return JSON.stringify(answerValue);
      }
      return String(answerValue);
    }

    if (typeof answerValue === "object") {
      return JSON.stringify(answerValue);
    }

    return String(answerValue);
  };

  getCombinedRating = (primary, secondary) => {
    const first = this.getNumericRating(primary);
    const second = this.getNumericRating(secondary);
    if (first != null && second != null) return (first + second) / 2;
    return first != null ? first : second;
  };

  getLabelForCombinedRating = (rating, labels = []) =>
    rating != null && labels?.length ? this.getRatingLabel(rating, labels) : "";

  resolveGoalRating = (goal, fallback = null) =>
    goal?.goal_score ?? goal?.self_assessment_rating ?? goal?.rating ?? fallback;

  normalizeGoalsFromResponse = (goals = [], isWeightAllow) =>
    goals.map(g => ({
      ...g,
      rating: this.resolveGoalRating(g, null),
      self_assessment_rating: g?.self_assessment_rating ?? this.resolveGoalRating(g, null),
      is_weight_allow: isWeightAllow
    }));

  buildGoalRatingsMap = (goals = []) =>
    goals.reduce((acc, g) => {
      acc[g.id] = this.resolveGoalRating(g, "");
      return acc;
    }, {});

  buildGoalRatingsSubmit = (goals = []) =>
    goals.map(g => ({
      goal_id: g.id,
      self_assessment_rating: this.resolveGoalRating(g, "")
    }));

  hasQuestionSubmission = (questions = []) =>
    questions.some(q => {
      const val = q?.assessment_value;
      const hasValue =
        (typeof val === "string" && val.trim() !== "") ||
        (val && typeof val === "object" && Object.keys(val).length > 0);
      const hasFile = !!q?.file_url;
      return hasValue || hasFile;
    });

  handleTabChange = (tab) => {
    const selectedStep = this.state.reviewSteps.find(s => s.id === tab);
    if (!selectedStep) return;

    this.setState(
      {
        activeTab: tab,
        selectedStep: selectedStep || null,

        reviewSubmittedListByManager: [],
        reviewSubmittedCatGroupListByManager: [],
        goalSubmittedListByManager: [],
        reviewRatingByManager: "",
        reviewRatingLabelByManager: "",
        goalRatingByManager: "",
        goalRatingLabelByManager: "",
        currentReviewStepStatus: null
      },
      () => {
        this.fetchAssessmentQuestionsForSelectedCycle();
      }
    );
  };

  fetchReviewQuestionsWithAnswers = async (reviewProcessStepId) => {
    const { selectedTimeframe, selectedCategory, selectedCheckIn } = this.state;
    const userId = CurrentUserStore.currentUser.id;
    if (!selectedTimeframe?.id || !reviewProcessStepId || !userId) return;

    this.setState({ isLoading: true });

    try {
      const payload = {
        goal_setting_id: selectedTimeframe.id,
        review_process_step_id: reviewProcessStepId,
        user_id: userId,

        ...(selectedCategory?.id && {
          question_category_id: selectedCategory.id
        }),

        ...(selectedCheckIn?.id && {
          checkin_id: selectedCheckIn.id
        })
      };

      const res = await axios.post(
        `${Cookies.get("apiEnv")}/review_questions/questions_with_answers`,
        payload
      );

      const responseBody = res?.data;
      const rawGroups = Array.isArray(responseBody)
        ? responseBody
        : (Array.isArray(responseBody?.data) ? responseBody.data : []);

      const avgQuestionRating = responseBody?.average_question_rating;
      const avgQuestionRatingLabel = responseBody?.average_question_rating_label;
      const avgGoalRating = responseBody?.average_goal_rating;
      const avgGoalRatingLabel = responseBody?.average_goal_rating_label;
      const goalsFromResponse = Array.isArray(responseBody?.goals)
        ? responseBody.goals
        : [];
      const normalizedGoalsFromResponse = this.normalizeGoalsFromResponse(
        goalsFromResponse,
        selectedTimeframe?.is_weight_allow
      );
      const goalRatingsFromResponse =
        this.buildGoalRatingsMap(normalizedGoalsFromResponse);
      const goalRatingsSubmitFromResponse =
        this.buildGoalRatingsSubmit(normalizedGoalsFromResponse);
      const hasGoalsFromResponse = normalizedGoalsFromResponse.length > 0;
      const goalStatePatch = hasGoalsFromResponse
        ? {
          goalList: normalizedGoalsFromResponse,
          goalSubmittedList: normalizedGoalsFromResponse,
          goalRatings: goalRatingsFromResponse,
          goalRatingsSubmit: goalRatingsSubmitFromResponse
        }
        : {};
      const finalRatingObj = responseBody?.final_rating;
      const finalRatingFromResponse =
        responseBody?.current_step_combine_rating ??
        (typeof finalRatingObj === "object" && finalRatingObj !== null
          ? finalRatingObj.final_rating
          : finalRatingObj) ?? "";
      const finalRatingLabelFromResponse =
        responseBody?.current_step_combine_rating_label ??
        (typeof finalRatingObj === "object" && finalRatingObj !== null
          ? finalRatingObj.final_rating_label
          : responseBody?.final_rating_label) ?? "";

      const basenameFromUrl = (url) => {
        try {
          if (!url || typeof url !== "string") return "";
          const withoutQuery = url.split("?")[0];
          const parts = withoutQuery.split("/");
          return parts[parts.length - 1] || "";
        } catch (_) {
          return "";
        }
      };

      const normalizeGroup = (group) => {
        const isNullCategory =
          group?.category_id == null ||
          group?.category_id === "null" ||
          group?.category_name == null ||
          group?.category_name === "null";

        return {
          category_id: isNullCategory ? "uncategorized" : group.category_id,
          category_name: isNullCategory ? "" : (group.category_name || ""),
          average_rating:
            group?.average_category_wise_rating ??
            group?.average_rating ??
            null,
          average_rating_label:
            group?.average_category_wise_rating_label ??
            group?.average_rating_label ??
            null,
          questions: (Array.isArray(group?.questions) ? group.questions : []).map(q => {
            const answerType = q?.answer_type || q?.question_type;
            const isFiles = answerType === "Files" || q?.question_type === "Files";

            const fileUrl = isFiles ? (q?.answer || q?.file_url || "") : (q?.file_url || "");
            const fileName =
              q?.file_name ||
              (isFiles ? basenameFromUrl(fileUrl) : "");

            const assessmentValue = isFiles
              ? (fileName || "")
              : this.parseAssessmentAnswerValue(
                q?.answer ?? "",
                answerType
              );

            return {
              ...q,
              question: q?.question,
              answer_type: answerType,
              assessment_value: assessmentValue,
              rating: q?.rating ?? null,
              weightage: q?.weightage ?? null,
              assessment_question_id: q?.id,
              file_url: isFiles ? fileUrl : q?.file_url,
            };
          }),
          remark_questions: (Array.isArray(group?.comment_questions) ? group.comment_questions : []).map(cq => ({
            id: cq.id,
            question:
              cq.question ||
              cq.remark_question ||
              cq.comment_question ||
              "",
            answer:
              cq.answer ??
              cq.category_comment_answer ??
              cq.comment_answer ??
              ""
          }))
        };
      };

      const reviewSubmittedCatGroupListByManager = rawGroups.map(normalizeGroup);
      const reviewSubmittedListByManager = reviewSubmittedCatGroupListByManager.flatMap(
        g => g.questions || []
      );

      this.setState({
        reviewSubmittedListByManager,
        reviewSubmittedCatGroupListByManager,
        goalSubmittedListByManager: normalizedGoalsFromResponse,
        reviewRatingByManager:
          avgQuestionRating !== undefined && avgQuestionRating !== null
            ? avgQuestionRating
            : "",
        reviewRatingLabelByManager: avgQuestionRatingLabel || "",
        goalRatingByManager:
          avgGoalRating !== undefined && avgGoalRating !== null
            ? avgGoalRating
            : "",
        goalRatingLabelByManager: avgGoalRatingLabel || "",
        responseFinalRating: finalRatingFromResponse,
        responseFinalRatingLabel: finalRatingLabelFromResponse,
        ...goalStatePatch,
        isLoading: false
      });
      if (hasGoalsFromResponse) await this.fetchSubGoalsForAllGoals(normalizedGoalsFromResponse);
    } catch (e) {
      console.error("Failed to load review questions/answers", e);
      this.setState({ isLoading: false });
    }
  };

  renderTabContent = () => {
    const {
      activeTab,
      selfAssessmentStatus,
      assessmentQuestionList,
      assessmentSubmittedList,
      assessmentSubmittedGroups,
      goalList,
      goalSubmittedList,
      finalAssessmentRating,
      finalAssesCalcRatingLabel,
      finalRating,
      finalGoalCalcRatingLabel,
      goalSubmittedRatingLabel,
      finalSubmittedAssessmentRating,
      finalSubmittedAssessmentRatingLabel,
      responseFinalRating,
      responseFinalRatingLabel,
      selectedTimeframe,
      goalRatings,
      reviewSubmittedListByManager,
      reviewSubmittedCatGroupListByManager,
      goalSubmittedListByManager,
      reviewRatingByManager,
      reviewRatingLabelByManager,
      goalRatingByManager,
      goalRatingLabelByManager,
      resultData,
      managerGlobalRating,
      managerGlobalRatingLabel,
      acknowledgementMode,
      acknowledgementData,
      multiLevelReview,
      reviewSteps,
      selectedStep,
      releaseStatus,
      accountId,
      accountVisibilityConfig,
      subGoalsByGoalId,
      openSubGoals,
      selectedCheckIn
    } = this.state;

    const ratingLabels = selectedTimeframe?.rating_labels || [];
    const hasResponseFinalRating =
      responseFinalRating !== null &&
      responseFinalRating !== undefined &&
      responseFinalRating !== "";

    const combinedSelfFinalRating = hasResponseFinalRating
      ? Number(responseFinalRating)
      : this.getCombinedRating(finalAssessmentRating, finalRating);

    const combinedSubmittedFinalRating = hasResponseFinalRating
      ? Number(responseFinalRating)
      : this.getCombinedRating(finalSubmittedAssessmentRating, finalRating);

    const subgoalProps = {
      subGoalsByGoalId,
      openSubGoals,
      toggleSubGoals: this.toggleSubGoals,
      accountId,
      accountVisibilityConfig
    };

    const activeStep =
      reviewSteps.find(s => s.id === activeTab) || selectedStep;

    const isOtherStepSelfAssignable = activeStep?.step_type === 2 && activeStep?.assign_type === 0;
    const isStepUnlocked = this.isStepContentUnlocked(activeStep);
    const isAcknowledgementStep = activeStep?.step_type === 2 && acknowledgementMode;

    if (activeStep && !isStepUnlocked) {
      return (
        <Card className="assessment-answer-container">
          <EmptyStateNotice
            title="Waiting for previous steps"
            description="This step will be available once earlier steps are submitted."
          />
        </Card>
      );
    }

    // Check if this is an Other step with status 2 (submitted) - should show read-only
    const isOtherStepWithSubmittedStatus = activeStep?.step_type === 2 && selfAssessmentStatus === SELF_ASSESSMENT_STATUS.SUBMITTED;

    if (isAcknowledgementStep) {
      return (
        <AcknowledgementTabContent acknowledgementData={acknowledgementData} />
      );
    }

    if (isOtherStepWithSubmittedStatus) {
      // Show read-only view for Other step when status is 2
      const hasAssessmentData = (assessmentSubmittedList?.length || 0) > 0;

      return (
        <>
          <Flexbox className="self-assessment-container" flexDirection="column">
            {hasAssessmentData && (
              <>
                <ContainerIntroBox
                  iconType="self"
                  text="Submitted Assessment Response"
                  description="View your submitted assessment responses"
                  // Hide all rating information for Other step read-only view
                  rating={null}
                  ratingLabel={null}
                  ratingLabels={[]}
                  finalAssessmentRatingLabel={null}
                  userGlobalRating={null}
                  userGlobalRatingLabel={null}
                  managerGlobalRating={null}
                  managerGlobalRatingLabel={null}
                  isRatingEnabledQuestions={false}
                  containerType="assessment"
                />

                <ReadOnlyNotice />
                <Card className="assessment-answer-container">
                  <AssessmentReadOnlyList
                    data={
                      assessmentSubmittedGroups?.length > 0
                        ? assessmentSubmittedGroups
                        : assessmentSubmittedList
                    }
                    // Hide rating and weightage for Other step read-only view
                    finalAssessmentRating={null}
                    weightage={false}
                    ratingLabels={[]}
                    isRatingEnabledQuestions={false}
                    accountId={accountId}
                    visibilityConfig={accountVisibilityConfig}
                    isAnswerAllowedOnQuestion={
                      selectedTimeframe?.is_answer_allow_on_question
                    }
                    hideRatingAndWeightage={true} // Custom prop to hide rating and weightage columns
                  />
                </Card>
              </>
            )}

            {!hasAssessmentData && (
              <Card className="assessment-answer-container">
                <EmptyStateNotice
                  title="No Submitted Data"
                  description="No assessment data has been submitted yet."
                />
              </Card>
            )}
          </Flexbox>
        </>
      );
    }

    if (!activeStep || activeStep.step_type === 0 || isOtherStepSelfAssignable) {
      return (
        <SelfTabContent
          isReadOnly={selectedCheckIn?.current_state === 0}
          selfAssessmentStatus={selfAssessmentStatus}
          assessmentQuestionList={
            Array.isArray(this.state.assessmentQuestionGroups) &&
              this.state.assessmentQuestionGroups.length > 0
              ? this.state.assessmentQuestionGroups
              : assessmentQuestionList
          }
          assessmentSubmittedList={assessmentSubmittedList}
          assessmentSubmittedGroups={assessmentSubmittedGroups}
          assessmentQuestionGroups={this.state.assessmentQuestionGroups}
          goalList={goalList}
          goalSubmittedList={goalSubmittedList}
          finalAssessmentRating={finalAssessmentRating}
          finalAssesCalcRatingLabel={finalAssesCalcRatingLabel}
          finalRating={finalRating}
          finalGoalCalcRatingLabel={finalGoalCalcRatingLabel}
          goalSubmittedRatingLabel={goalSubmittedRatingLabel}
          finalSubmittedAssessmentRating={finalSubmittedAssessmentRating}
          finalSubmittedAssessmentRatingLabel={finalSubmittedAssessmentRatingLabel}
          selectedTimeframe={selectedTimeframe}
          goalRatings={goalRatings}
          onRatingChange={this.handleGoalRatingChange}
          onAssessmentRatingChange={this.handleAssessmentRatingChange}
          onChange={this.handleChange}
          onCheckboxChange={this.handleCheckboxChange}
          onFileUpload={this.handleFileUpload}
          onSubmitForm={this.handleSubmitForm}
          SELF_ASSESSMENT_STATUS={SELF_ASSESSMENT_STATUS}
          combinedSelfFinalRating={combinedSelfFinalRating}
          combinedSelfFinalRatingLabel={
            responseFinalRatingLabel ||
            this.getLabelForCombinedRating(combinedSelfFinalRating, ratingLabels)
          }
          combinedSubmittedFinalRating={combinedSubmittedFinalRating}
          combinedSubmittedFinalRatingLabel={
            responseFinalRatingLabel ||
            this.getLabelForCombinedRating(combinedSubmittedFinalRating, ratingLabels)
          }
          answers={this.state.answers}
          assessmentRatings={this.state.assessmentRatings}
          categoryWiseRatings={this.state.categoryWiseRatings}
          remarkAnswers={this.state.remarkAnswers}
          updateRemarkAnswer={this.handleRemarkAnswerChange}
          setShowPublishConfirm={show => this.setState({ showPublishConfirm: show })}
          hideGoalSection={activeStep?.step_type === 2}
          hideRatingSummary={activeStep?.step_type === 2}
          hideQuestionRatings={activeStep?.step_type === 2}
          showEmptySelfStepActions={isOtherStepSelfAssignable}
          {...subgoalProps}
        />
      );
    }

    const managerProps = {
      releaseStatus,
      reviewSubmittedListByManager,
      reviewSubmittedCatGroupListByManager,
      goalSubmittedListByManager,
      reviewRatingByManager,
      reviewRatingLabelByManager,
      goalRatingByManager,
      goalRatingLabelByManager,
      responseFinalRating,
      responseFinalRatingLabel,
      selectedTimeframe,
      resultData,
      managerGlobalRating,
      managerGlobalRatingLabel,
      reviewStepStatus: this.state.currentReviewStepStatus,
      ...subgoalProps
    };

    const step = reviewSteps.find(s => s.id === activeTab);
    return <ReviewTabContent {...managerProps} step={step} multiLevelReview={multiLevelReview} />;
  };

  componentDidMount() {
    const cycleIdFromUrl = this.getCycleIdFromUrl();
    this.getAllGoalCycleList(cycleIdFromUrl).catch(error => {
      console.error("Failed to fetch initial data", error);
    });
  }
  getCycleIdFromUrl = () => {
    const params = new URLSearchParams(window.location.search);
    const encoded = params.get("cycle");
    return encoded ? atob(encoded) : null;
  };

  getSubGoalListParams = (goalId, managerId = null) => {
    const { selectedTimeframe } = this.state;

    const params = {
      goal_setting_id: selectedTimeframe.id,
      goal_id: goalId,
      user_id: CurrentUserStore.currentUser.id
    };

    if (managerId) {
      params.manager_id = managerId;
    }

    return params;
  };

  toggleSubGoals = (goalId) => {
    this.setState(prev => ({
      openSubGoals: {
        ...prev.openSubGoals,
        [goalId]: !prev.openSubGoals[goalId]
      }
    }));
  };

  getAllGoalCycleList = (cycleIdFromUrl = null) => {
    const previousCheckIn = this.state.selectedCheckIn;
    this.setState({ isLoading: true, selectedCheckIn: previousCheckIn, });

    return new Promise((resolve, reject) => {
      axios
        .get(`${Cookies.get("apiEnv")}/goal_settings/goal_cycle_list`)
        .then(response => {
          const goalCycleList = response.data;

          if (goalCycleList.length > 0) {

            const firstCycle = goalCycleList[0];

            const alreadySelected = this.state.selectedTimeframe?.id
              ? goalCycleList.find(cycle => cycle.id === this.state.selectedTimeframe.id)
              : null;

            let selectedCycle = firstCycle;

            if (cycleIdFromUrl) {
              const matchedCycle = goalCycleList.find(
                cycle => cycle.id === cycleIdFromUrl
              );

              if (matchedCycle) {
                selectedCycle = matchedCycle;
              }
            } else if (alreadySelected) {
              selectedCycle = alreadySelected;
            }

            const currentStepId = this.state.selectedStep?.id || this.state.activeTab;
            const isSameCycle = this.state.selectedTimeframe?.id === selectedCycle.id;
            const preservedActiveTab = isSameCycle && currentStepId ? currentStepId : "assessment";
            const preservedSelectedStep = isSameCycle ? this.state.selectedStep : null;

            this.setState(
              {
                goalCycleList,
                selectedTimeframe: selectedCycle,
                showCheckInDropdown: selectedCycle.is_checkin_enable === 1, // <-- Add this
                multiLevelReview: !!selectedCycle.is_review_level,
                activeTab: preservedActiveTab,
                reviewSteps: [],
                selectedStep: preservedSelectedStep,
                check_in: [],
              },
              async () => {
                if (selectedCycle.is_checkin_enable === 1) {
                  await this.handleCheckIn();
                } else {
                  this.setState({
                    check_in: [],
                    selectedCheckIn: null,
                  });
                }

                await this.fetchReviewLevels(isSameCycle ? currentStepId : null, false);

                const { status, releaseStatus } =
                  await this.fetchSelfAssessmentStatus();

                const promises = [];
                promises.push(this.fetchGoalsForSelectedCycle(status, false));
                promises.push(this.fetchAssessmentQuestionsForSelectedCycle(status, false));

                if (
                  this.state.reviewSteps.length === 0 &&
                  releaseStatus
                ) {
                  promises.push(this.getSubmittedReviewByManager(null, false));
                  promises.push(this.getSubmittedGoalsByManager(null, false));
                }

                await Promise.all(promises);

                this.setState({ isLoading: false });
              }
            );
          } else {
            this.setState({ goalCycleList: [], selectedTimeframe: {}, isLoading: false });
          }
        })
        .catch(error => {
          this.setState({ error: "Failed to load", isLoading: false });
          ToastStore.showToast("Failed to load Goals Cycles!", "danger");
          reject(error);
        });
    });
  };

  fetchSelfAssessmentStatus = async () => {
    const { selectedTimeframe } = this.state;
    const userId = CurrentUserStore.currentUser.id;

    try {
      const res = await axios.get(
        `${Cookies.get("apiEnv")}/assessments/assessment_submission_status`,
        {
          params: {
            user_id: userId,
            goal_setting_id: selectedTimeframe.id
          }
        }
      );

      const status = res?.data?.status ?? 0;
      const releaseStatus = !!res?.data?.released_status;

      this.setState({ selfAssessmentStatus: status, releaseStatus: releaseStatus });

      return { status, releaseStatus };
    } catch (e) {
      console.error("Failed to fetch assessment status", e);
      this.setState({ selfAssessmentStatus: 0 });
      return { status: 0, releaseStatus: false };
    }
  };

  fetchSubGoalsForAllGoals = async (goalList = [], managerId = null) => {
    try {
      const entries = await Promise.all(goalList.map(async goal => {
        if (Array.isArray(goal.sub_goals)) return [goal.id, goal.sub_goals];
        const response = await axios.get(`${Cookies.get("apiEnv")}/sub_goals`, {
          params: this.getSubGoalListParams(goal.id, managerId)
        });
        const data = response.data;
        return [goal.id, Array.isArray(data) ? data : (Array.isArray(data?.sub_goals) ? data.sub_goals : [])];
      }));
      const subGoalsByGoalId = {};
      entries.forEach(([id, children]) => { subGoalsByGoalId[id] = children; });
      this.setState({ subGoalsByGoalId, openSubGoals: {} });
    } catch (error) {
      console.error("Subgoal fetch failed", error);
    }
  };

  fetchGoalsForSelectedCycle = (
    status = this.state.selfAssessmentStatus,
    showLoader = true
  ) => {
    const { selectedTimeframe } = this.state;
    const userId = CurrentUserStore.currentUser.id;

    if (showLoader) this.setState({ isLoading: true });

    // 🔹 Always fetch goals
    const goalsRequest = axios.get(
      `${Cookies.get("apiEnv")}/assessments/assessment_goals_for_review`,
      {
        params: { goal_setting_id: selectedTimeframe.id }
      }
    );

    const ratingsRequest =
      status === 1 || status === 2
        ? axios.get(
          `${Cookies.get("apiEnv")}/assessments/goal_rating_data`,
          {
            params: {
              goal_setting_id: selectedTimeframe.id,
              user_id: userId
            }
          }
        )
        : Promise.resolve({ data: null });

    return Promise.all([goalsRequest, ratingsRequest])
      .then(([goalsRes, ratingsRes]) => {
        const rawGoalList = Array.isArray(goalsRes.data)
          ? goalsRes.data
          : goalsRes.data?.goals || [];

        const goalList = (rawGoalList || []).map(g => ({
          ...g,
          is_weight_allow: selectedTimeframe?.is_weight_allow
        }));

        let goalRatings = {};
        let goalRatingsSubmit = [];
        let finalRating = "";
        let goalSubmittedRatingLabel = "";

        if (ratingsRes?.data) {
          const answered = (ratingsRes.data.answered_goals || []).map(g => ({
            ...g,
            is_weight_allow: selectedTimeframe?.is_weight_allow
          }));

          goalRatings = answered.reduce((acc, g) => {
            acc[g.id] = g.self_assessment_rating;
            return acc;
          }, {});

          goalRatingsSubmit = answered.map(g => ({
            goal_id: g.id,
            self_assessment_rating: g.self_assessment_rating
          }));

          finalRating = ratingsRes.data.final_rating || "";
          goalSubmittedRatingLabel = ratingsRes.data.rating_label || "";
        }

        this.setState({
          goalList,
          goalSubmittedList:
            (ratingsRes?.data?.answered_goals || []).map(g => ({
              ...g,
              is_weight_allow: selectedTimeframe?.is_weight_allow
            })),
          goalRatings,
          goalRatingsSubmit,
          finalRating,
          goalSubmittedRatingLabel,
          ...(showLoader ? { isLoading: false } : {})
        });
        this.fetchSubGoalsForAllGoals(goalList);
      })
      .catch(() => {
        if (showLoader) this.setState({ isLoading: false });
      });
  };

  fetchAssessmentQuestionsForSelectedCycle = (
    status = this.state.selfAssessmentStatus,
    showLoader = true
  ) => {
    const { selectedTimeframe, selectedCategory, selectedCheckIn } = this.state;
    const userId = CurrentUserStore.currentUser.id;

    if (showLoader) this.setState({ isLoading: true });

    const reviewProcessStepId = this.getCurrentReviewProcessStepId();

    if (!reviewProcessStepId) {
      if (showLoader) this.setState({ isLoading: false });
      return Promise.resolve();
    }

    return axios.post(
      `${Cookies.get("apiEnv")}/review_questions/questions_with_answers`,
      {
        goal_setting_id: selectedTimeframe.id,
        review_process_step_id: reviewProcessStepId,
        user_id: userId,

        ...(selectedCategory?.id && {
          question_category_id: selectedCategory.id
        }),

        ...(selectedCheckIn?.id && {
          checkin_id: selectedCheckIn.id
        })
      }
    )
      .then(response => {
        const responseStatus =
          response.data?.status !== undefined &&
            response.data?.status !== null
            ? Number(response.data.status)
            : status || 0;
        const currentStep = this.getCurrentReviewStep();
        const isReviewStep = Number(currentStep?.step_type) === 1;
        let rawGroups = [];

        if (Array.isArray(response.data)) {
          rawGroups = response.data;
        } else if (Array.isArray(response.data?.data)) {
          rawGroups = response.data.data;
        } else if (Array.isArray(response.data?.categories)) {
          rawGroups = response.data.categories;
        }

        const hasQuestionData = rawGroups.some(
          cat => Array.isArray(cat.questions) && cat.questions.length > 0
        );
        const isAcknowledgementMode =
          currentStep?.step_type === 2 && !hasQuestionData;

        const remarkAnswersFromApi = rawGroups.flatMap(cat => [
          ...(cat.remark_answers || []),
          ...(cat.remark_questions || []),
          ...(cat.comment_questions || [])
        ]);

        const remarkAnswersMap = remarkAnswersFromApi.reduce((acc, ra) => {
          acc[ra.remark_question_id || ra.id] = ra.answer || ra.category_comment_answer || "";
          return acc;
        }, {});

        const groupedQuestions = rawGroups.map(cat => {
          const normalized = {
            category_id: cat?.category_id || "uncategorized",
            category_name: cat?.category_name || "",
            average_rating:
              cat?.average_category_wise_rating ??
              cat?.average_rating ??
              null,
            average_rating_label:
              cat?.average_category_wise_rating_label ??
              cat?.average_rating_label ??
              ""
          };

          return {
            ...normalized,
            questions: (cat.questions || []).map(q => {
              const questionType = q.question_type || q.answer_type || "";
              const hasOptions = questionType === "Checkbox" || questionType === "Radio" || questionType === "DropDown";

              return {
                ...q,
                id: q.id,
                question: q.question,
                assessment_question_id: q.id,
                assessment_value: this.parseAssessmentAnswerValue(
                  q.answer ?? q.assessment_value ?? "",
                  questionType
                ),
                answer_type: questionType,
                question_type: questionType,
                value: hasOptions ? q.value : {},
                rating: q.rating ?? q.assessment_rating ?? null,
                weightage: q.weightage ?? null,
                file_url: questionType === "Files" ? (q.answer || q.file_url || "") : ""
              };
            }),
            remark_questions: (cat.remark_questions || cat.comment_questions || []).map(cq => ({
              id: cq.id || cq.remark_question_id,
              question: cq.question || cq.remark_question || cq.comment_question || "",
              answer: cq.answer || cq.category_comment_answer || cq.comment_answer || ""
            })),
            comment_questions: (cat.comment_questions || cat.remark_questions || []).map(cq => ({
              id: cq.id || cq.remark_question_id,
              question: cq.question || cq.remark_question || cq.comment_question || "",
              answer: cq.answer || cq.category_comment_answer || cq.comment_answer || ""
            }))
          };
        });

        const flatQuestions = groupedQuestions.flatMap(g => g.questions || []);

        const answers = flatQuestions.map(q => ({
          assessment_question_id: q.assessment_question_id,
          assessment_value: q.assessment_value,
          answer_type: q.answer_type,
          rating: q.rating
        }));

        const assessmentRatings = answers.reduce((acc, a) => {
          if (a.rating !== undefined && a.rating !== null) {
            acc[a.assessment_question_id] = a.rating;
          }
          return acc;
        }, {});

        const averageQuestionRating =
          response.data?.average_question_rating ??
          response.data?.final_assessment_rating ??
          "";
        const averageQuestionRatingLabel =
          response.data?.average_question_rating_label ??
          response.data?.rating_label ??
          "";
        const averageGoalRating =
          response.data?.average_goal_rating ??
          "";
        const averageGoalRatingLabel =
          response.data?.average_goal_rating_label ??
          "";
        const goalsFromResponse = Array.isArray(response.data?.goals)
          ? response.data.goals
          : [];
        const normalizedGoalsFromResponse = this.normalizeGoalsFromResponse(
          goalsFromResponse,
          selectedTimeframe?.is_weight_allow
        );
        const goalRatingsFromResponse =
          this.buildGoalRatingsMap(normalizedGoalsFromResponse);
        const goalRatingsSubmitFromResponse =
          this.buildGoalRatingsSubmit(normalizedGoalsFromResponse);
        const hasGoalsFromResponse = normalizedGoalsFromResponse.length > 0;
        const goalStatePatch = hasGoalsFromResponse
          ? {
            goalList: normalizedGoalsFromResponse,
            goalSubmittedList: normalizedGoalsFromResponse,
            goalRatings: goalRatingsFromResponse,
            goalRatingsSubmit: goalRatingsSubmitFromResponse
          }
          : {};
        const finalRatingObj = response.data?.final_rating;
        const finalRatingFromResponse =
          response.data?.current_step_combine_rating ??
          (typeof finalRatingObj === "object" && finalRatingObj !== null
            ? finalRatingObj.final_rating
            : finalRatingObj) ?? "";
        const finalRatingLabelFromResponse =
          response.data?.current_step_combine_rating_label ??
          (typeof finalRatingObj === "object" && finalRatingObj !== null
            ? finalRatingObj.final_rating_label
            : response.data?.final_rating_label) ?? "";

        const hasQuestionSubmission = this.hasQuestionSubmission(flatQuestions);

        // step_type=2 behavior:
        // - Published should remain readonly when this step has actual answers
        // - Draft/empty or unfilled self-assignable other steps remain editable
        const effectiveResponseStatus =
          currentStep?.step_type === 2
            ? (hasQuestionSubmission
              ? responseStatus
              : SELF_ASSESSMENT_STATUS.NOT_SUBMITTED)
            : responseStatus;

        const reviewGoalsFromResponse = Array.isArray(response.data?.goals)
          ? response.data.goals.map(g => ({
            ...g,
            is_weight_allow: selectedTimeframe?.is_weight_allow
          }))
          : [];

        this.setState({
          assessmentQuestionGroups: groupedQuestions,
          assessmentQuestionList: flatQuestions,
          assessmentSubmittedList: answers,
          assessmentSubmittedGroups: groupedQuestions,
          remarkAnswers: remarkAnswersMap,
          answers,
          assessmentRatings,
          // Show API averages at top of questions card
          finalAssessmentRating: averageQuestionRating,
          finalAssesCalcRatingLabel: averageQuestionRatingLabel,
          finalSubmittedAssessmentRating: averageQuestionRating,
          finalSubmittedAssessmentRatingLabel: averageQuestionRatingLabel,
          // Keep goal averages available for combined/header usage
          finalRating: averageGoalRating,
          finalGoalCalcRatingLabel: averageGoalRatingLabel,
          goalSubmittedRatingLabel: averageGoalRatingLabel,
          responseFinalRating: finalRatingFromResponse,
          responseFinalRatingLabel: finalRatingLabelFromResponse,
          reviewRatingByManager: averageQuestionRating,
          reviewRatingLabelByManager: averageQuestionRatingLabel,
          goalRatingByManager: averageGoalRating,
          goalRatingLabelByManager: averageGoalRatingLabel,
          reviewSubmittedCatGroupListByManager: isReviewStep ? groupedQuestions : [],
          reviewSubmittedListByManager: isReviewStep ? flatQuestions : [],
          goalSubmittedListByManager: isReviewStep ? reviewGoalsFromResponse : [],
          acknowledgementMode: isAcknowledgementMode,
          acknowledgementData: response.data?.acknowledged_data || null,
          ...goalStatePatch,
          selfAssessmentStatus: effectiveResponseStatus,
          currentReviewStepStatus: isReviewStep ? responseStatus : null,
          categoryWiseRatings: {},
          ...(showLoader ? { isLoading: false } : {})
        }, () => {
          if (hasGoalsFromResponse) this.fetchSubGoalsForAllGoals(normalizedGoalsFromResponse);
          if (currentStep?.step_type !== 2) {
            this.calculateCategoryWiseAssessmentRating();
          }
        });
      })
      .catch((err) => {
        console.error("❌ Error fetching questions:", err);
        if (showLoader) this.setState({ isLoading: false });
      });
  };

  fetchReviewLevels = (preferredStepId = null, showLoader = true) => {
    const { selectedTimeframe } = this.state;
    if (!selectedTimeframe || !selectedTimeframe.id) return Promise.resolve();

    if (showLoader) this.setState({ isLoading: true });

    return new Promise((resolve, reject) => {
      axios
        .get(`${Cookies.get("apiEnv")}/performance_steps`, {
          params: {
            goal_setting_id: selectedTimeframe.id,
            user_id: CurrentUserStore.currentUser.id
          }
        })
        .then(res => {
          const reviewLevels = Array.isArray(res?.data) ? res.data : [];

          const mapped = reviewLevels.map(item => {
            const isSubmitted = Boolean(
              item.is_submitted === true ||
              Number(item.is_submitted) === 1 ||
              item.is_review_submitted === true ||
              Number(item.is_review_submitted) === 1
            );

            return {
              id: item.id,
              goal_setting_id: item.goal_setting_id,
              step_name: item.step_name,
              step_type: item.step_type,
              assign_type: item.assign_type,
              assignee_list: item.assignee_list || [],
              assigned_user_id: Array.isArray(item.assignee_list) ? item.assignee_list[0] : null,
              is_submitted: isSubmitted,
              is_review_submitted: isSubmitted ? 2 : 0
            };
          });

          const firstTab = mapped?.[0]?.id || "assessment";
          const activeTab = preferredStepId && mapped.some(s => s.id === preferredStepId)
            ? preferredStepId
            : firstTab;

          const firstStep = mapped?.find(
            s => s.id === activeTab
          );

          this.setState({
            reviewSteps: mapped,
            ...(showLoader ? { isLoading: false } : {}),
            activeTab,
            selectedStep: firstStep
          }, () => {
            resolve();
          });
        })
        .catch(error => {
          ToastStore.showToast("Failed to fetch performance steps", "danger");
          if (showLoader) this.setState({ isLoading: false });
          reject(error);
        });
    });
  };

  handleSelectStep = step => {
    if (!step) return;

    this.setState(
      {
        selectedStep: step,
        reviewSubmittedListByManager: [],
        reviewRatingByManager: "",
        reviewRatingLabelByManager: "",
        goalSubmittedListByManager: [],
        goalRatingByManager: "",
        goalRatingLabelByManager: ""
      },
      () => {
        this.loadStepReviewData();
      }
    );
  };


  /**
   * Load manager review data based on step status:
   * 0 = pending, 1 = submitted, 2 = skipped
   */
  loadStepReviewData = () => {
    const { selectedStep } = this.state;
    if (!selectedStep) return;

    const status = selectedStep.is_review_submitted;
    const managerId = selectedStep.assigned_user_id;

    // 0 → review not submitted yet
    if (status === 0 || status === 1) {
      // just show "Waiting for Manager Review" in render
      this.setState({
        reviewSubmittedListByManager: [],
        goalSubmittedListByManager: []
      });
      return;
    }

    // 2 → skipped
    if (status === 3) {
      // show "Review Skipped" in render
      this.setState({
        reviewSubmittedListByManager: [],
        goalSubmittedListByManager: []
      });
      return;
    }

    // 1 → submitted → fetch review + goals for that manager
    if (status === 2 && managerId) {
      this.getSubmittedGoalsByManager(managerId);
    }
  };

  /**
   * Manager review of employee (single or multi-level)
   * For multi-level, pass managerId from step
   */
  getSubmittedReviewByManager = (managerId, showLoader = true) => {
    const { selectedTimeframe, multiLevelReview } = this.state;
    const userId = CurrentUserStore.currentUser.id;
    if (!selectedTimeframe || !selectedTimeframe.id) return Promise.resolve();

    if (showLoader) this.setState({ isLoading: true });

    let url = `${Cookies.get("apiEnv")}/manager_assessments/fetch_questions_and_answers?goal_setting_id=${selectedTimeframe.id}&user_id=${userId}`;

    if (multiLevelReview && managerId) {
      url += `&manager_id=${managerId}`;
    }

    return axios
      .get(url)
      .then(response => {

        let submittedGroups = [];
        let reviewSubmittedListByManager = [];
        let reviewSubmittedCatGroupListByManager = [];

        const answerData = response.data;

        const buildSubmittedGroups = (data) => {
          if (!data?.categories?.length) return [];

          return data.categories.map((category) => {
            const categoryId =
              !category.category_id || category.category_id === "null"
                ? "uncategorized"
                : category.category_id;

            return {
              category_id: categoryId,
              category_name: category.category_name || "",
              average_rating: category.avg_rating ?? "",
              answered_assessment: (category.questions || []).map((q) => ({
                id: q.id,
                answer_type: q.answer_type,
                assessment_value: q.assessment_value,
                rating: q.rating,
                assessment_question: q.manager_assessment_question,
                options: q.options || {},
                assessment_question_id: q.manager_assessment_question_id,
                assessment_question_weightage:
                  q.assessment_question_weightage ?? null
              })),
              remark_questions: (category.remark_answers || [])
                .filter(r => r?.remark_question)
                .map(r => ({
                  id: r.remark_question_id,
                  question: r.remark_question,
                  answer: r.answer || ""
                }))
            };
          });
        };

        submittedGroups = buildSubmittedGroups(answerData);

        // Correct flatten (FIXED KEY)
        const answers = submittedGroups.flatMap(
          (group) => group.answered_assessment || []
        );

        reviewSubmittedListByManager = answers;
        reviewSubmittedCatGroupListByManager = submittedGroups;

        this.setState({
          reviewSubmittedListByManager,
          reviewSubmittedCatGroupListByManager,
          reviewRatingByManager: response.data.manager_assessment_review_rating,
          reviewRatingLabelByManager: response.data.assessment_rating_label,
          goalRatingByManager: response.data.goal_manager_final_rating,
          goalRatingLabelByManager: response.data.goal_rating_label,
          managerGlobalRating: response.data.manager_global_rating,
          managerGlobalRatingLabel: response.data.manager_global_rating_label,
          ...(showLoader ? { isLoading: false } : {})
        });
      })
      .catch(error => {
        if (showLoader) this.setState({ isLoading: false });
        console.error("Failed to load goals!", "danger", error);
      });
  };

  /**
   * Manager goal rating (single or multi-level)
   * For multi-level, pass managerId from step
   */
  getSubmittedGoalsByManager = (managerId, showLoader = true) => {
    const { selectedTimeframe, multiLevelReview } = this.state;
    const userId = CurrentUserStore.currentUser.id;

    if (!selectedTimeframe || !selectedTimeframe.id) return Promise.resolve();

    if (showLoader) this.setState({ isLoading: true });

    let url = `${Cookies.get("apiEnv")}/assessments/manager_goal_data?goal_setting_id=${selectedTimeframe.id}&user_id=${userId}`;

    if (multiLevelReview && managerId) {
      url += `&manager_id=${managerId}`;
    }

    return axios
      .get(url)
      .then(response => {
        const goals = (response.data.answered_goals || []).map(g => ({
          ...g,
          is_weight_allow: selectedTimeframe?.is_weight_allow
        }));

        this.setState({
          goalSubmittedListByManager: goals,
          ...(showLoader ? { isLoading: false } : {})
        });

        this.fetchSubGoalsForAllGoals(goals, managerId);

      })
      .catch(error => {
        if (showLoader) this.setState({ isLoading: false });
        ToastStore.showToast("Failed to load user submitted goals!", "danger");
      });
  };

  handleSelectTimeframe = timeframe => {
    this.setState(
      {
        selectedTimeframe: timeframe,
        showCheckInDropdown: timeframe.is_checkin_enable === 1,
        isDropdownOpen: false,
        isSubmitted: false,
        multiLevelReview: !!timeframe.is_review_level,
        activeTab: "assessment",
        reviewSteps: [],
        selectedStep: null,

        reviewSubmittedListByManager: [],
        reviewRatingByManager: "",
        reviewRatingLabelByManager: "",
        goalSubmittedListByManager: [],
        goalRatingByManager: "",
        goalRatingLabelByManager: "",
        check_in: [],
        selectedCheckIn: null,
        isLoading: true
      },
      async () => {
        if (timeframe.is_checkin_enable === 1) {
          await this.handleCheckIn(false);
        } else {
          this.setState({
            check_in: [],
            selectedCheckIn: null,
          });
        }
        
        await this.fetchReviewLevels(null, false);
        const { status, releaseStatus } = await this.fetchSelfAssessmentStatus();

        const promises = [];
        promises.push(this.fetchGoalsForSelectedCycle(status, false));
        promises.push(this.fetchAssessmentQuestionsForSelectedCycle(status, false));

        if (releaseStatus && this.state.reviewSteps.length === 0) {
          promises.push(this.getSubmittedReviewByManager(null, false));
          promises.push(this.getSubmittedGoalsByManager(null, false));
        }
        
        await Promise.all(promises);
        this.setState({ isLoading: false });
      }
    );
  };

  handleSelectCheckIn = checkIn => {
    if (checkIn.current_state === 2) {
      return;
    }

    this.setState(
      { selectedCheckIn: checkIn },
      () => {
        this.fetchAssessmentQuestionsForSelectedCycle();

        const stepId = this.getCurrentReviewProcessStepId();
        if (stepId) {
          this.fetchReviewQuestionsWithAnswers(stepId);
        }
      }
    );
  };

  handleCheckIn = async (showLoader = true) => {
    const { selectedTimeframe, selectedCheckIn } = this.state;

    if (!selectedTimeframe?.id) return;

    try {
      if (showLoader) this.setState({ isLoadingCheckIn: true });

      const res = await axios.get(
        `${Cookies.get("apiEnv")}/onboarding_steps/checkins_by_cycle`,
        {
          params: {
            goal_cycle_id: selectedTimeframe.id
          }
        }
      );

      const list = Array.isArray(res.data) ? res.data : [];

      console.log("Check-in List", list);

      const currentSelection =
        list.find(item => item.current_state === 1) ||
        list.find(item => item.current_state === 0) ||
        null;

      console.log("Selected Check-in", currentSelection);

      this.setState({
        check_in: list,
        selectedCheckIn: currentSelection
      });

    } catch (e) {
      ToastStore.showToast("Failed to load Check-In", "danger");
    } finally {
      if (showLoader) {
        this.setState({
          isLoadingCheckIn: false
        });
      }
    }
  };

  getRatingLabel = (finalRating, labels = []) => {
    const rating = Number(finalRating);
    if (!labels.length) return "";
    // CASE 1 → Handle values below 0.5 (or below half of lowest value)
    const firstValue = labels[0].value;
    if (rating <= firstValue - 0.5) {
      return labels[0].label;
    }

    // CASE 2 → Normal midpoint logic
    for (const item of labels) {
      const min = item.value - 0.5;
      const max = item.value + 0.5;

      if (rating >= min && rating < max) {
        return item.label;
      }
    }

    // CASE 3 → If exceeds highest
    return labels[labels.length - 1].label;
  };

  handleGoalRatingChange = (goalId, value, goalWeight) => {
    const { goalList, selectedTimeframe } = this.state;

    const normalizedValue = value === "" ? "" : String(value);
    this.setState(
      prevState => {
        const newGoalRatings = {
          ...prevState.goalRatings,
          [goalId]: normalizedValue
        };

        const newGoalRatingsSubmit = [
          ...prevState.goalRatingsSubmit.filter(entry => entry.goal_id !== goalId),
          { goal_id: goalId, self_assessment_rating: normalizedValue === "" ? "" : Number(normalizedValue) }
        ];

        const newGoalRatingsCalculation = [
          ...prevState.goalRatingsCalculation.filter(entry => entry.goal_id !== goalId),
          { goal_id: goalId, rating: normalizedValue, weightage: goalWeight }
        ];

        return {
          goalRatings: newGoalRatings,
          goalRatingsSubmit: newGoalRatingsSubmit,
          goalRatingsCalculation: newGoalRatingsCalculation
        };
      },
      () => {
        const { goalRatingsCalculation, goalList, goalRatings } = this.state;


        const ratingsPayload = goalList.map(g => {
          const raw = goalRatings[g.id];
          const rating =
            raw === "" || raw === undefined || raw === null ? "" : Number(raw);
          return {
            rating,
            ...(selectedTimeframe.is_weight_allow && { weightage: Number(g.goal_weight) })
          };
        });
        const hasAnyValidRating = ratingsPayload.some(
          r => typeof r.rating === "number" && r.rating >= 0
        );

        const payload = {
          ratings: ratingsPayload,
          no_of_goals: goalList.length
        };


        axios
          .post(`${Cookies.get("apiEnv")}/assessments/rating_calculation`, payload)
          .then(response => {
            if (!hasAnyValidRating) {
              this.setState({
                finalAssessmentRating: null,
                finalAssesCalcRatingLabel: "-"
              });
              return;
            }
            const finalRating = response.data.final_rating;
            const finalGoalCalcRatingLabel = this.getRatingLabel(
              finalRating,
              (selectedTimeframe && selectedTimeframe.rating_labels) || []
            );
            this.setState({
              finalRating: response.data.final_rating,
              finalGoalCalcRatingLabel,
              responseFinalRating: response.data.final_rating,
              responseFinalRatingLabel: finalGoalCalcRatingLabel
            });
          })
          .catch(error => {
            ToastStore.showToast("Failed to calculate rating", "danger");
          });
      }
    );
  };

  categoryWiseRatingPayload = () => {

    const {
      assessmentQuestionGroups,
      assessmentRatings,
      selectedTimeframe
    } = this.state;

    if (!assessmentQuestionGroups?.length) return { categories: [] };

    return {
      categories: assessmentQuestionGroups.map(group => {

        const catId =
          !group.category_id ||
            group.category_id === "null"
            ? "uncategorized"
            : group.category_id;

        return {
          category_id: catId,

          ratings: (group.questions || []).map(q => {

            const ratingVal = assessmentRatings[q.id];
            const weightage = Number(q.weightage || 0);

            // Send -1 for unselected so backend excludes from calculation (same as NA)
            const rating =
              ratingVal === "" ||
                ratingVal === undefined ||
                ratingVal === null ||
                Number.isNaN(Number(ratingVal))
                ? ""
                : Number(ratingVal);

            return {
              rating,

              ...(selectedTimeframe.is_weight_allow && {
                weightage
              })
            };
          })
        };
      })
    };
  };

  calculateCategoryWiseAssessmentRating = () => {

    const payload = this.categoryWiseRatingPayload();

    if (!payload.categories?.length) return;

    // Track which categories actually have at least one selected rating
    const categoryHasSelection = {};
    payload.categories.forEach(cat => {
      categoryHasSelection[cat.category_id] = (cat.ratings || []).some(
        r => typeof r.rating === "number" && !Number.isNaN(r.rating)
      );
    });

    const hasAnySelectedRating = Object.values(categoryHasSelection).some(Boolean);

    // Don't show any category avg on initial load when nothing is selected yet
    if (!hasAnySelectedRating) {
      this.setState({ categoryWiseRatings: {}, categoryFinalRating: "" });
      return;
    }

    axios
      .post(`${Cookies.get("apiEnv")}/assessments/ratings_by_category`, payload)
      .then(res => {

        const categoryWiseRatings = {};

        (res?.data?.categories || []).forEach(cat => {
          // Only show avg for categories where the user selected at least one rating
          if (!categoryHasSelection[cat.category_id]) {
            return;
          }
          categoryWiseRatings[cat.category_id] = {
            avg: cat.average_rating,
            naCount: cat.na_count
          };
        });

        this.setState({
          categoryWiseRatings,
          categoryFinalRating: res?.data?.final_rating || ""
        });

      })
      .catch(() => {
        ToastStore.showToast("Category rating calculation failed", "danger");
      });
  };

  updateAnswer = (questionId, updateData) => {
    this.setState(prevState => {
      const { answers } = prevState;
      const existingIndex = answers.findIndex(a => a.assessment_question_id === questionId);
      let updatedAnswers = [...answers];

      if (existingIndex !== -1) {
        updatedAnswers[existingIndex] = {
          ...updatedAnswers[existingIndex],
          ...updateData
        };
      } else {
        updatedAnswers.push({
          assessment_question_id: questionId,
          ...updateData
        });
      }

      return { answers: updatedAnswers };
    });
  };

  handleRemarkAnswerChange = (remarkId, value) => {
    this.setState(prevState => ({
      remarkAnswers: {
        ...prevState.remarkAnswers,
        [remarkId]: value
      }
    }));
  };

  handleChange = (question, value) => {
    this.updateAnswer(question.id, {
      answer_type: question.answer_type,
      assessment_value: value
    });
  };

  handleFileUpload = (question, file) => {

    if (!file) {
      this.updateAnswer(question.id, {
        answer_type: question.answer_type,
        assessment_value: "",
        assessment_file: null
      });

      return;
    }

    const MAX_SIZE = 15 * 1024 * 1024;
    const extension = file.name.split(".").pop().toLowerCase();

    if (
      file.size > MAX_SIZE ||
      !allowedExtensions.includes(extension)
    ) {
      ToastStore.showToast(
        "File size should not exceed 10MB and allowed file are PDF, Word, Document, Excel, Image, PowerPoint",
        "danger"
      );
      return;
    }

    this.updateAnswer(question.id, {
      answer_type: question.answer_type,
      assessment_file: file,
      assessment_value: file.name
    });
  };

  handleCheckboxChange = (question, optionKey, checked) => {
    const existingAnswer = this.state.answers.find(a => a.assessment_question_id === question.id);

    // Handle both object and empty string cases - ensure we work with an object
    const currentValue = existingAnswer?.assessment_value;
    const baseValue = (typeof currentValue === "object" && currentValue !== null) ? currentValue : {};
    let updatedValues = { ...baseValue };

    if (checked) {
      updatedValues[optionKey.key] = optionKey.value;
    } else {
      delete updatedValues[optionKey.key];
    }

    this.updateAnswer(question.id, {
      answer_type: question.answer_type,
      assessment_value: updatedValues
    });
  };

  handleAssessmentRatingChange = (questionId, value, weightage) => {
    const normalizedRating = value === "" ? "" : String(value);
    this.updateAnswer(questionId, { rating: normalizedRating === "" ? "" : Number(normalizedRating) });

    this.setState(
      prevState => {
        const newAssessmentRatings = {
          ...prevState.assessmentRatings,
          [questionId]: normalizedRating
        };

        const newAssessmentRatingsCalculation = [
          ...prevState.assessmentRatingsCalculation.filter(
            entry => entry.assessment_question_id !== questionId
          ),
          {
            assessment_question_id: questionId,
            // keep "" for no selection, numeric (including -1 for NA) otherwise
            rating: normalizedRating === "" ? "" : Number(normalizedRating),
            weightage: Number(weightage)
          }
        ];

        return {
          assessmentRatings: newAssessmentRatings,
          assessmentRatingsCalculation: newAssessmentRatingsCalculation
        };
      },
      () => {

        this.calculateAssessmentRating();

        // Find category of changed question
        const { assessmentQuestionGroups } = this.state;

        let changedQuestionCategory = null;

        assessmentQuestionGroups.forEach(group => {
          if (group.questions?.some(q => q.id === questionId)) {
            changedQuestionCategory = group.category_id;
          }
        });

        // If Uncategorized → Skip Category API
        if (
          !changedQuestionCategory ||
          changedQuestionCategory === "uncategorized" ||
          changedQuestionCategory === "null"
        ) {
          return;
        }

        // Only call if categorized question changed
        this.calculateCategoryWiseAssessmentRating();
      }
    );
  };

  calculateAssessmentRating = () => {
    const { assessmentRatings, assessmentQuestionList, selectedTimeframe } = this.state;

    const ratingsPayload = assessmentQuestionList.map(q => {
      const raw = assessmentRatings[q.id];
      const rating =
        raw === "" || raw === undefined || raw === null ? "" : Number(raw);
      return {
        rating,
        ...(selectedTimeframe.is_weight_allow && { weightage: Number(q.weightage) })
      };
    });
    const hasAnyValidRating = ratingsPayload.some(
      r => typeof r.rating === "number" && r.rating >= 0
    );

    const payload = {
      ratings: ratingsPayload,
      no_of_goals: assessmentQuestionList.length
    };

    axios.post(`${Cookies.get("apiEnv")}/assessments/rating_calculation`, payload)
      .then(res => {
        if (!hasAnyValidRating) {
          this.setState({
            finalAssessmentRating: null,
            finalAssesCalcRatingLabel: "-"
          });
          return;
        }
        const finalRating = res.data.final_rating;
        const finalAssesCalcRatingLabel = this.getRatingLabel(
          finalRating,
          selectedTimeframe.rating_labels || []
        );
        this.setState({
          finalAssessmentRating: res.data.final_rating,
          finalAssesCalcRatingLabel,
          responseFinalRating: res.data.final_rating,
          responseFinalRatingLabel: finalAssesCalcRatingLabel
        });
      });
  };

  parseAssessmentAnswerValue = (rawValue, answerType) => {
    if (
      rawValue === null ||
      rawValue === undefined ||
      rawValue === "-"
    ) {
      return "";
    }

    // Only parse Checkbox JSON string
    if (
      answerType === "Checkbox" &&
      typeof rawValue === "string"
    ) {
      const trimmed = rawValue.trim();

      // Parse only JSON-like values
      if (
        (trimmed.startsWith("{") && trimmed.endsWith("}")) ||
        (trimmed.startsWith("[") && trimmed.endsWith("]"))
      ) {
        try {
          return JSON.parse(trimmed);
        } catch (e) {
          return rawValue;
        }
      }
    }

    return rawValue;
  };

  handleSubmitForm = (status) => {
    const {
      goalRatingsSubmit,
      finalAssessmentRating,
      finalRating,
      selectedTimeframe,
      answers,
      goalRatings,
      goalList,
      assessmentQuestionList,
      SPECIAL_ACCOUNT_ID,
      assessmentQuestionGroups,
      remarkAnswers,
      // selectedCheckIn
    } = this.state;


    const shouldSkipAllValidation = CurrentUserStore.activeAccount.accountId === SPECIAL_ACCOUNT_ID;
    const allowAnswerValidation = selectedTimeframe.is_answer_allow_on_question === 1;
    const allowRatingValidation = selectedTimeframe.is_assessment_question_rating === 1;
    const currentStep = this.getCurrentReviewStep();
    const isStepType2 = currentStep?.step_type === 2;
    const selectedCheckIn = this.state.selectedCheckIn;
    const isSelfPerformanceStep =
      !currentStep ||
      currentStep.step_type === 0 ||
      (currentStep.step_type === 2 && currentStep.assign_type === 0);
    // For step_type=2, rating and goal validation should never block publish.
    const effectiveAllowRatingValidation =
      !isStepType2 && allowRatingValidation;

    if (!this.isCurrentUserAuthorizedToSubmitCurrentStep()) {
      ToastStore.showToast(
        'You are not authorized to submit this review. Only the assigned reviewer can submit this step.',
        'danger'
      );
      return;
    }

    if (!shouldSkipAllValidation) {

      // Validation for goal ratings
      const ratedGoalIds = goalRatingsSubmit.map(r => r.goal_id);
      const safeGoalList = Array.isArray(goalList) ? goalList : [];
      const missingRatings =
        isStepType2 || safeGoalList.length === 0
          ? []
          : safeGoalList.filter(goal => !ratedGoalIds.includes(goal.id));

      // Validation for assessment answers (only if questions exist)
      let missingAssessmentQuestions = [];
      if (assessmentQuestionList.length > 0) {
        missingAssessmentQuestions = assessmentQuestionList.filter(q => {
          const answer = answers.find(a => a.assessment_question_id === q.id);
          // If both OFF → no validation
          if (!allowAnswerValidation && !effectiveAllowRatingValidation) return false;
          // Rating validation
          if (effectiveAllowRatingValidation) {
            if (!answer || answer.rating === undefined || answer.rating === null || answer.rating === "") {
              return true;
            }
          }
          if (allowAnswerValidation) {
            if (!answer) return true;
            const type = q.answer_type || answer.answer_type;
            if (type === "Checkbox") {
              if (!answer.assessment_value || Object.keys(answer.assessment_value).length === 0) {
                return true;
              }
            } else {
              if (!answer.assessment_value || answer.assessment_value === "") {
                return true;
              }
            }
          }
          return false;
        });
      }

      const hasMissingFields =
        missingRatings.length > 0 || missingAssessmentQuestions.length > 0;

      if (hasMissingFields) {
        const missingItems = [
          missingRatings.length > 0 ? "- Some goal ratings are missing." : "",
          missingAssessmentQuestions.length > 0 ? "- Some assessment ratings/answers are missing." : ""
        ].filter(Boolean);
        const message = `Some fields are incomplete:\n${missingItems.join("\n")}`;
        if (status === 2) {
          ToastStore.showToast(
            "Please complete all required fields before final submission.\n" + message,
            "danger"
          );
          return;
        }
        ToastStore.showToast(
          "Saved as draft with incomplete fields.\n" + message,
          "warning"
        );
      }
    }

    const goalsPayload = goalList.map(goal => {
      const rawRating = goalRatings[goal.id];
      const normalizedRating =
        rawRating === "" || rawRating === undefined || rawRating === null
          ? null
          : Number(rawRating);

      return {
        goal_id: goal.id,
        goal_rating: normalizedRating,
        self_assessment_rating: normalizedRating
      };
    });

    this.setState({ isLoading: true });
    const payload = {
      goal_setting_id: selectedTimeframe.id,
      goals: goalsPayload,
      final_rating: finalRating,
      status: status,
      ...(selectedCheckIn?.id && {
        checkin_id: selectedCheckIn.id
      }),
    };

    const accountId = CurrentUserStore.activeAccount.accountId;
    const userId = CurrentUserStore.currentUser.id;

    const remarkAnswersPayload = [];

    (assessmentQuestionGroups || []).forEach(group => {
      (group.remark_questions || []).forEach(remark => {
        const category_comment_question_id = remark.id;
        // Always include the remark keys. Backend expects these fields
        // even if user hasn't typed anything (empty string).
        const category_comment_answer = remarkAnswers?.[remark.id] ?? "";

        remarkAnswersPayload.push({
          category_comment_question_id,
          category_comment_answer,
          account_id: accountId,
          goal_setting_id: selectedTimeframe.id,
          remark_type: remark.remark_type,
          question_category_id: group.category_id,
          user_id: userId,
          manager_id: null
        });
      });
    });

    if (remarkAnswersPayload.length > 0) payload.remark_answers = remarkAnswersPayload;

    const shouldIncludeAnswerRow = (q, existing) => {
      if (!existing) return false;

      const answerType =
        existing.answer_type || q?.answer_type || q?.question_type;

      const value = existing.assessment_value;

      const hasRating =
        existing.rating !== undefined &&
        existing.rating !== null &&
        existing.rating !== "";

      const hasFile = existing.assessment_file instanceof File;

      // NEW: detect previously uploaded file
      const hadPreviousFile =
        q?.file_url ||
        (typeof value === "string" && value.trim() !== "");

      if (answerType === "Files") {
        return hasFile || hadPreviousFile || hasRating;
      }

      if (answerType === "Checkbox") {
        const hasChecked =
          value &&
          typeof value === "object" &&
          Object.keys(value).length > 0;

        return hasChecked || hasRating;
      }

      if (typeof value === "string") {
        return value.trim() !== "" || hasRating;
      }

      if (value && typeof value === "object") {
        return Object.keys(value).length > 0 || hasRating;
      }

      return hasRating;
    };

    if (assessmentQuestionList.length > 0) {
      payload.answers = assessmentQuestionList
        .map(q => {
          const existing = answers.find(a => a.assessment_question_id === q.id);
          if (!shouldIncludeAnswerRow(q, existing)) return null;

          return {
            assessment_question_id: q.id,
            answer_type: q.answer_type,
            assessment_value: existing?.assessment_value || "",
            rating: Number(
              existing?.rating ?? this.state.assessmentRatings[q.id] ?? 0
            ),
            assessment_file: existing?.assessment_file || null
          };
        })
        .filter(Boolean);

      payload.assessment_final_rating =
        finalAssessmentRating === null || finalAssessmentRating === undefined
          ? ""
          : finalAssessmentRating;
    }

    payload.final_rating =
      finalRating === null || finalRating === undefined ? "" : finalRating;

    const reviewProcessStepId = this.getCurrentReviewProcessStepId();
    const subjectUserId = isSelfPerformanceStep
      ? CurrentUserStore.currentUser.id
      : this.getCurrentReviewUserId();
    const submittedByUserId = this.getSubmittedByUserId();
    const averageGoalRatingForReview =
      finalRating === null || finalRating === undefined ? "" : finalRating;
    const averageReviewRatingForReview =
      finalAssessmentRating === null || finalAssessmentRating === undefined
        ? ""
        : finalAssessmentRating;

    const basePayload = {
      goal_setting_id: selectedTimeframe.id,
      goals: goalsPayload,
      status: status,
      average_goal_rating: averageGoalRatingForReview,
      average_review_rating: averageReviewRatingForReview,
      ...(selectedCheckIn?.id && {
        checkin_id: selectedCheckIn.id
      }),
      answers: assessmentQuestionList
        .map(q => {
          const existing = answers.find(a => a.assessment_question_id === q.id);
          if (!shouldIncludeAnswerRow(q, existing)) return null;

          const answerType =
            existing?.answer_type || q.answer_type || q.question_type;
          const answerValue = existing?.assessment_value || "";

          return {
            review_question_id: q.id,
            answer_type: answerType,
            answer: this.formatReviewAnswerValue(answerValue, answerType),
            rating:
              existing?.rating !== undefined && existing?.rating !== null
                ? Number(existing.rating)
                : undefined
          };
        })
        .filter(Boolean)
    };

    if (reviewProcessStepId) {
      basePayload.review_process_step_id = reviewProcessStepId;
      basePayload.user_id = subjectUserId;
      basePayload.submitted_by = submittedByUserId;
    }

    if (remarkAnswersPayload.length > 0) basePayload.remark_answers = remarkAnswersPayload;

    const apiUrl = reviewProcessStepId
      ? `${Cookies.get("apiEnv")}/review_questions/review_submissions`
      : `${Cookies.get("apiEnv")}/assessments/goal_rating_submit`;

    const buildGoalRatingPayloadForWire = source => {
      const out = { ...source };
      out.final_rating =
        source.final_rating === null || source.final_rating === undefined
          ? ""
          : source.final_rating;
      out.assessment_final_rating =
        source.assessment_final_rating === null ||
          source.assessment_final_rating === undefined
          ? ""
          : source.assessment_final_rating;
      if (!source.answers) return out;
      out.answers = source.answers.map(a => ({
        assessment_question_id: a.assessment_question_id,
        answer_type: a.answer_type,
        assessment_value: a.assessment_value ?? "",
        rating: Number(a.rating) || 0,
        assessment_file:
          a.answer_type === "Files"
            ? (
              a.assessment_file instanceof File
                ? {}
                : null
            )
            : null
      }));
      return out;
    };

    const hasAssessmentFile =
      !reviewProcessStepId &&
      payload.answers?.some(a => a.assessment_file instanceof File);

    const hasReviewFile =
      !!reviewProcessStepId &&
      (basePayload.answers || []).some(ans => {
        const row = answers.find(a => a.assessment_question_id === ans.review_question_id);
        return row?.assessment_file instanceof File;
      });

    // review_submissions multipart: same as goal_rating_submit — JSON in `payload`,
    // binary in `files[<review_question_id>]`; optional `answer_file` {} / null per row (DevTools parity).
    const buildReviewPayloadForWire = bp => ({
      ...bp,
      answers: (bp.answers || []).map((ans) => {
        const existing = answers.find(a => a.assessment_question_id === ans.review_question_id) || {};
        const q =
          assessmentQuestionList.find(qq => qq.id === ans.review_question_id) ||
          {};
        const answerType = existing.answer_type || q?.answer_type || q?.question_type;
        return {
          ...ans,
          answer_file:
            answerType === "Files"
              ? (
                existing.assessment_file instanceof File
                  ? {}
                  : null
              )
              : null
        };
      })
    });

    let requestData;
    let config = {};

    if (reviewProcessStepId && hasReviewFile) {
      const formData = new FormData();
      formData.append(
        "payload",
        JSON.stringify(buildReviewPayloadForWire(basePayload))
      );
      (basePayload.answers || []).forEach(ans => {
        const existing = answers.find(a => a.assessment_question_id === ans.review_question_id);
        if (existing?.assessment_file instanceof File) {
          formData.append(`files[${ans.review_question_id}]`, existing.assessment_file);
        }
      });
      requestData = formData;
    } else if (reviewProcessStepId) {
      requestData = basePayload;
    } else if (hasAssessmentFile) {
      const formData = new FormData();
      formData.append(
        "payload",
        JSON.stringify(buildGoalRatingPayloadForWire(payload))
      );
      (payload.answers || []).forEach(ans => {
        if (ans.assessment_file instanceof File) {
          formData.append(
            `files[${ans.assessment_question_id}]`,
            ans.assessment_file
          );
        }
      });
      requestData = formData;
    } else {
      requestData = buildGoalRatingPayloadForWire(payload);
    }

    axios
      .post(apiUrl, requestData, config)
      .then(response => {
        this.setState(
          {
            isLoading: false,
            isSubmitted: true
          },
          async () => {
            await this.getAllGoalCycleList();

            // restore selected check-in
            this.setState(
              {
                selectedCheckIn
              },
              () => {
                const refreshedStatus =
                  Number(status) || this.state.selfAssessmentStatus;

                this.fetchGoalsForSelectedCycle(refreshedStatus);
                this.fetchAssessmentQuestionsForSelectedCycle(refreshedStatus);
              }
            );

            ToastStore.showToast("Successfully Submitted", "success");
          }
        );
      })
      .catch(error => {
        this.setState({ isLoading: false });

        const fallbackMessage = "Something went wrong while submitting. Please try again.";
        const apiErrorMessage = this.getSafeErrorMessage(error, fallbackMessage);

        ToastStore.showToast(apiErrorMessage, "danger");
        console.error("Error submitting goal rating:", error);
      });
  };

  getSafeErrorMessage = (error, fallbackMessage = "Something went wrong. Please try again.") => {
    const payload = error?.response?.data || error?.data || {};
    const candidates = [
      payload?.message,
      payload?.error,
      payload?.errors,
      payload?.detail,
      payload?.error?.message,
      payload?.errors?.message,
      error?.message
    ];

    const flatten = value => {
      if (typeof value === 'string') return [value.trim()].filter(Boolean);
      if (Array.isArray(value)) {
        return value.flatMap(item => flatten(item));
      }
      if (value && typeof value === 'object') {
        return Object.values(value).flatMap(item => flatten(item));
      }
      return [];
    };

    const messages = candidates.flatMap(candidate => flatten(candidate));
    const cleanMessage = messages.find(message => typeof message === 'string' && message.trim());

    return cleanMessage || fallbackMessage;
  };

  toggleDropdown = () => {
    this.setState(prevState => ({ isDropdownOpen: !prevState.isDropdownOpen }));
  };

  renderOptions = value => {
    if (typeof value === "string") {
      value = JSON.parse(value);
    }
    return Object.entries(value).map(([key, option]) => (
      <option key={key} value={option}>
        {option}
      </option>
    ));
  };

  render() {
    const stores = {
      CurrentUserStore,
      ToastStore
    };
    const {
      selectedTimeframe,
      goalCycleList,
      releaseStatus,
      isLoading,
      check_in,
      selectedCheckIn,
      isLoadingCheckIn
    } = this.state;

    const tabs = this.getTabs();

    const filteredGoalCycles =
      goalCycleList.length > 0 && selectedTimeframe.id
        ? goalCycleList.filter(gc => gc.id !== selectedTimeframe.id)
        : goalCycleList;

    const accountId = CurrentUserStore.activeAccount.accountId;

    return (
      <Provider {...stores}>
        <ThemeWrapper>
          <ErrorBoundary>
            <Flexbox
              flexGrow={1}
              alignContent="stretch"
              flexDirection="column"
              style={{
                width: '100%',
                maxWidth: '100%',
                minWidth: 0,
                boxSizing: 'border-box',
                paddingLeft: 20,
                paddingRight: 20,
                overflowX: 'visible',
              }}
            >
              {!isLoading ? (
                <>
                  <PageHeading
                    text="My Performance Review"
                    description="Complete your performance evaluation and reflect on your achievements and growth opportunities."
                  />
                  <Flexbox
                    flexDirection="row"
                    justifyContent="flex-end"
                    style={{
                      width: '100%',
                      maxWidth: '100%',
                      minWidth: 0,
                      overflow: 'visible',
                      boxSizing: 'border-box',
                    }}
                  >
                    <div
                      style={{
                        width: selectedTimeframe?.is_checkin_enable === 1 ? "550px" : "250px",
                        display: "flex",
                        gap: "16px",
                        justifyContent: "flex-end",
                        alignItems: "flex-start",
                      }}
                    >
                      {/* Goal Cycle */}
                      <div
                        style={{
                          flex: 1,
                          display: "flex",
                          flexDirection: "column",
                          gap: "4px",
                        }}
                      >
                        <span
                          style={{
                            fontSize: "13px",
                            fontWeight: 500,
                            color: "black",
                          }}
                        >
                          Goal Cycle
                        </span>

                        <ScrollableDropdown
                          width={250}
                          label={selectedTimeframe.title || "Goal Cycle"}
                          items={filteredGoalCycles || []}
                          getKey={g => g.id}
                          getLabel={g => g.title}
                          enableSearch
                          onSelect={this.handleSelectTimeframe}
                        />
                      </div>

                      {/* Check-in */}
                      {selectedTimeframe?.is_checkin_enable === 1 && (
                        <div
                          style={{
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            gap: "4px",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "13px",
                              fontWeight: 500,
                              color: "black",
                            }}
                          >
                            Check-in
                          </span>

                          <ScrollableDropdown
                            width={250}
                            label={selectedCheckIn?.title || "Select Check-in"}
                            items={check_in}
                            getKey={item => item.id}
                            getLabel={item => item.title}
                            onSelect={this.handleSelectCheckIn}
                            renderItem={item => (
                              <span
                                style={{
                                  opacity: item.current_state === 2 ? 0.4 : 1,
                                  color: item.current_state === 2 ? "#221f1f" : "#222",
                                }}
                              >
                                {item.title}
                              </span>
                            )}
                            isItemDisabled={item => item.current_state === 2}
                          />
                        </div>
                      )}
                    </div>
                  </Flexbox>

                  <PerformanceTabSelector
                    activeTab={this.state.activeTab}
                    onTabChange={this.handleTabChange}
                    accountId={accountId}
                    tabs={tabs}
                  />
                  {this.renderTabContent()}
                </>
              ) : (
                <Flexbox
                  flexGrow={1}
                  flexDirection="column"
                  justifyContent="center"
                  alignItems="center"
                  style={{ marginTop: "230px" }}
                >
                  <img
                    style={{ height: "35px", width: "35px" }}
                    src="https://s01.live2support.com/dashboardv2/chatassets/img/loader_new.gif"
                    alt="Please wait"
                  />
                </Flexbox>
              )}
              <PublishConfirmDialog
                isOpen={this.state.showPublishConfirm}
                onClose={() => this.setState({ showPublishConfirm: false })}
                onConfirm={() => {
                  this.setState({ showPublishConfirm: false }, () => {
                    this.handleSubmitForm(SELF_ASSESSMENT_STATUS.SUBMITTED);
                  });
                }}
              />
            </Flexbox>
          </ErrorBoundary>
        </ThemeWrapper>
      </Provider>
    );
  }
}